




















module.exports =
  components:
    list: require('./list')
    newCustomFieldsModal: require('./new_modal')

  data: ->
    edit_custom_field: new CustomField()

  methods:
    customFieldCreated: (custom_field) ->
      @$refs.list.addCustomField(custom_field)

    showCreateModal: ->
      @edit_custom_field = new CustomField()
      @openModal()

    openModal: ->
      jQuery("#new-custom-fields-modal").modal 'show'

    closeCreateModal: ->
      @edit_custom_field = new CustomField()
      jQuery("#new-custom-fields-modal").modal 'hide'

    edit: (custom_field) ->
      new CustomFieldsResource().get(@loadCustomFieldSuccess, null, { id: custom_field.id })

    loadCustomFieldSuccess: (data) ->
      @edit_custom_field = data.custom_field
      @openModal()

    created: (custom_field) ->
      @closeCreateModal()
      @$refs.list.addCustomField(custom_field)

    updated: (custom_field) ->
      @closeCreateModal()
      @$refs.list.customFieldUpdated(custom_field)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/custom_fields/index.vue